import React from 'react';
import './Vacancy2026Page.css';

function Vacancy2026Page({ vacancyReport, vacancyAdvertisement , firstMeritFourthRound }) {
  const documents = [
    {
      title: '1st Merit 4th Round Active',
      file: firstMeritFourthRound,
      filename: '1st Merit 4th Round Active.pdf',
    },
    {
      title: 'Vacancy Report Against CAP Round 2026',
      file: vacancyReport,
      filename: 'vacancy-report-cap-round-2026.pdf',
    },
    {
      title: 'Advertisement of Vacancy',
      file: vacancyAdvertisement,
      filename: 'advertise-of-vacancy.pdf',
    },

  ];

  return (
    <div className="vacancy-page">
      <h1>Vacancy of 2026</h1>
      <p>View or download the vacancy-related documents below.</p>

      <div className="vacancy-documents">
        {documents.map((document) => (
          <div className="vacancy-card" key={document.title}>
            <h2>{document.title}</h2>

            <iframe
              src={document.file}
              title={document.title}
              width="100%"
              height="500px"
            />

            <a
              href={document.file}
              download={document.filename}
              className="vacancy-download"
            >
              Download PDF
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Vacancy2026Page;
